module.exports = __webpack_public_path__ + "static/media/mangrove-snapper.459655c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/fish/mangrove-snapper.png
// module id = 322
// module chunks = 0